/** Search surface polish — real-estate list text search + shorts aria (shared header.search). */

const realEstate = {
  searchPlaceholder: [
    '매물 제목·주소 검색',
    'Search by title or address',
    'Tìm theo tiêu đề hoặc địa chỉ',
    'Поиск по названию или адресу',
  ],
  searchAria: ['매물 검색', 'Search listings', 'Tìm tin đăng', 'Поиск объявлений'],
};

const jobs = {
  searchSubmitGlobal: [
    '전체 검색에서 보기',
    'Open in full search',
    'Xem trong tìm kiếm đầy đủ',
    'Открыть в общем поиске',
  ],
};

function pick(map, langIndex) {
  const out = {};
  Object.entries(map).forEach(([k, arr]) => {
    out[k] = arr[langIndex];
  });
  return out;
}

function buildLang(langIndex) {
  return {
    realEstate: pick(realEstate, langIndex),
    jobs: pick(jobs, langIndex),
  };
}

export const phaseSearchSurfaceKo = buildLang(0);
export const phaseSearchSurfaceEn = buildLang(1);
export const phaseSearchSurfaceVi = buildLang(2);
export const phaseSearchSurfaceRu = buildLang(3);
